export enum ToastText {
  UNAVAILABLE_ITEM_SELECTION_IF_NOT_IN_STOCK = '사용 부품이 없음은, 하단 부품 선택이 불가 합니다.',
  UNAVAILABLE_ITEM_SELECTION_IF_NO_REPAIR = '수리 안함은, 하단 부품 선택이 불가 합니다.',
  PLEASE_SELECT_ITEM_AT_LEAST_ONE = '수리할 부품을 선택해주세요.',
  PLEASE_TYPE_MANUTAL_INPUT_TEXT = '기타 사유를 입력해주세요.',
  PLEASE_TYPE_VALID_BIKE_CODE = '번호 6자리로 입력해주세요.',
  INVALID_CODE = '기기명을 다시 확인해주세요.',
  ALREADY_ACCESSED_CODE = '이미 등록된 코드입니다',
  CONFIRM_VIDEO_PERMISSION = '카메라 권한을 확인해주세요.',
  UNEXPECTED_ERROR = '알수없는 오류가 발생했습니다.',
  CANNOT_CHANGE_REGION = '지역 변경에 실패했습니다. 다시 시도해주세요.',
  CANNOT_UPDATE_BASE_POINT = '거점 변경에 실패했습니다. 다시 시도해주세요.',
  CANNOT_GET_WORK_STATUS = '내 작업 정보를 불러오는데 실패했습니다.',
  CANNOT_GET_MY_BASE_REGIONS = '지역 데이터를 가져오는데 실패했습니다.',
  CANNOT_GET_DEVICES_COUNT = '디바이스 정보를 가져오는데 실패했습니다.',
  CANNOT_GET_BASE_POINT = '거점 정보를 가져오는데 실패했습니다.',
  CANNOT_UPDATE_TICKET = '티켓을 처리하는데 실패했습니다.',
  CONFIRM_ACCOUNT = '아이디 또는 비밀번호를 확인해주세요.',
  CANNOT_PROCEED = '작업을 수행하는 도중 오류가 발생하였습니다.',
  NO_LAST_TRIP_DATA = '바이크의 최종 경로 정보가 없습니다.',
  CHECK_LOCATION_FOR_BEEP = '비프음 재생을 위해 5초간 위치를 수집합니다.',
  NO_ACCESS_PERMISSION = '접근 권한이 없습니다.',
  NOT_FOUND = '요청한 정보를 찾을 수 없습니다.',
  SERVER_ERROR = '일시적인 서버 오류가 발생했습니다.',
  REQUEST_ERROR = '잘못된 요청입니다.',
  NO_SUPPORT_FLASH = '플랫폼에서 플래시 라이트를 지원하지 않습니다.',
  INVALID_BATTERY_CODE = '배터리 코드 포맷을 다시 확인해주세요.',
  INVALID_BATTERY_CODE_PREFIX = '배터리 코드는 "10" 으로 시작해야합니다.',
  DEVICE_NOT_CONNECT_TO_SERVER = '기기가 서버에 연결되어 있지 않습니다.',
  BATTERY_LOCK_OPEN_SUCCESS = '배터리 락이 열렸습니다.',
  HUB_LOCK_CLOSE_SUCCESS = '허브락이 닫혔습니다.',
  RESTART_SUCCESS = '재시작 요청 성공하였습니다.',
  TBIT_SMART_LOCK_OPEN_SUCCESS = '스마트 락이 열렸습니다.',
  NET_SIGNAL_WEAK = '네트워크 신호가 약합니다. 신호가 강한 곳으로 이동후 다시 시도해주세요',
  PERIODIC_REPORT_REQ_FAIL = '주기보고 요청이 실패 했습니다. 네트워크 연결이 복구될 때까지 잠시 기다려주세요',
  NET_SIGNAL_WEAK_REPEAT = '네트워크 신호가 약합니다. 이동후 다시 시도해주세요. 문제가 반복될 경우 입고 수리로 전환해주세요',
  FAIL_TO_GET_FUSHIDA_BATTERY = '요청사항을 처리하지 못했습니다. 신호가 강한곳으로 이동후 다시 시도해주세요',
  NET_SIGNAL_WEAK_REPEAT_LINE_BREAK = '네트워크 신호가 약합니다.<br/>이동후 다시 시도해주세요. 문제가 반복될 경우 입고 수리로 전환해주세요',
  UNKNOWN_ERROR = '알 수 없는 오류가 발생하였습니다.',
}
